import type { CSS } from '../stitches.config';
import { selectors, transitions } from '../controls/shared/styles';
import { css, darkThemeSelector, shadows } from '../stitches.config';

/**
 * A `::before` that carries a focus halo, laid out and empty until focus fills it in. It has to
 * exist before focus: one conjured by it has no previous `box-shadow` to animate from, so the halo
 * would snap in and vanish out.
 */
export const focusRingPseudoElement = (inset: string, borderRadius: string): CSS => ({
  content: '',
  position: 'absolute',
  inset,
  borderRadius,
  pointerEvents: 'none',
  transition: transitions.focusRing,
});

export const FocusRing = css({
  position: 'relative',
  zIndex: 0,
  transition: transitions.control,
  [selectors.hover]: {
    zIndex: 1,
  },
  [selectors.focus]: {
    zIndex: 2,
    outline: 'none',
    boxShadow: shadows.focusRingLight,
    [darkThemeSelector]: {
      boxShadow: shadows.focusRingDark,
    },
  },
});
